import { create } from 'zustand'
import type { ReactNode } from 'react'

interface FooterActionsStore {
  content: ReactNode | null
  set:     (content: ReactNode) => void
  clear:   () => void
}

/**
 * Contenido del footer fijo del layout (AppLayout → FooterActionBar). Las
 * vistas lo alimentan envolviendo sus botones finales en
 * <StickyActionBar>...</StickyActionBar> (@/components/ui/StickyActionBar) —
 * nunca directo contra este store.
 */
export const useFooterActionsStore = create<FooterActionsStore>(set => ({
  content: null,
  set:   content => set({ content }),
  clear: () => set({ content: null }),
}))
